import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import store from '../store'
import Cookies from 'js-cookie';
import { itil } from './itil';
import { member } from './member';
// import { monitoring } from './monitoring';
import { operation } from './operation';
import { sale } from './sale';
import { system } from './system';
import { home } from './home';
import { finance } from './finance';
import {splitAccounting} from './splitAccounting';
import { merchantPromotionalCoupons } from './merchant-promotional-coupons';
import { device } from './device';
// import WebsocketMessage from '../helper/WebsocketMessage';
// import globalNotify from '../global-message';

const Login = () => import(/*webpackChunkName:'others'*/'@/page/login.vue')

const RouteTemp = () => import(/*webpackChunkName:'others'*/'@/page/commons/routeTemp.vue')
//首页
const Home = () => import(/*webpackChunkName:'others'*/'@/page/home.vue')

const HomePage = () => import(/*webpackChunkName:'others'*/'@/page/home.vue')

// const Home = () => import(/*webpackChunkName:'others'*/'@/page/monitoring/home/home.vue')

const Main = () => import(/*webpackChunkName:'others'*/'@/page/main.vue')

// const MainLayOut = () => import(/*webpackChunkName:'others'*/'@/page/mainLayOut.vue')

// const originalPush =Router.prototype.push;

// Router.prototype.push = function push(location) {


//   return originalPush.call(this, location).catch(err => err)

// }
const router = new Router({
    base: process.env.BASE_URL,
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/main/cityFacts/all',
            name: '城市概况',
            meta: {
                requireAuth: true,
            },
            component: Home
        },
        {
            path: '/main',
            // name: '首页',
            component: Main,
            children: [
                home,
                itil,
                member,
                sale,
                system,
                operation,
                finance,
                splitAccounting,
                merchantPromotionalCoupons,
                device
            ]
        }

    ]
})

router.beforeEach((to, from, next) => {
    console.log('to path=>',to)
    console.log('from path=>',from)
    store.commit('getPage', {
        curIndex: 1,
        rowsCount: 0
    })
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        // console.log(Cookies.get('Authorization'))
        if (Cookies.get('Authorization')) {  // 通过vuex state获取当前的token是否存在
            // 添加到标签页历史记录（首页不参与）
            if (to.name && to.path && to.path !== '/main/home') {
                store.dispatch('tabs/addView', {
                    path: to.path,
                    name: to.name,
                    meta: to.meta
                })
            }
            next();
        }
        else {
            next({
                path: '#/',
                query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        // 添加到标签页历史记录（首页不参与）
        if (to.name && to.path && to.path !== '/' && to.path !== '/main/home') {
            store.dispatch('tabs/addView', {
                path: to.path,
                name: to.name,
                meta: to.meta
            })
        }
        next();
    }

   
    // console.log("websocket message=>",WebsocketMessage.message)
    // const hash = window.location.hash;
    // if (hash === '#/') {
    //     globalNotify.unsubscribe();
    // }
    // else if (hash==='#/main/home'){
      
    // }else{
    //     globalNotify.subscribe();
    // }

})
export default router;